// Lane helpers shared by the location-column day grids (DivisionPage and the
// tournament Day2 scheduler). The grids key their X axis on Location lanes;
// these helpers give games WITHOUT a resolvable location a synthetic lane so
// they still render — one unlabeled lane when the org has no courts at all,
// an extra "Unassigned" column when real court lanes exist alongside.

export const UNASSIGNED_LANE_ID = '__unassigned__';

// True only for a real Location ObjectId — synthetic lane ids (the unassigned
// lane, and the `name:<string>` lanes built from string-only game locations)
// must never be written into the `locationModel` ref field.
export const isRealLocationId = (v: unknown): v is string =>
  typeof v === 'string' && /^[a-f\d]{24}$/i.test(v);

export interface ScheduleLane {
  _id: string;
  name: string;
  synthetic?: boolean;
  [key: string]: unknown;
}

/**
 * Append the synthetic unassigned lane when any of the day's games resolves to
 * no lane id. Label rule (owner decision 2026-09-21): empty header when it is
 * the ONLY lane (no courts configured — the lane IS the schedule), "Unassigned"
 * when real court lanes exist alongside.
 */
export const appendUnassignedLane = (
  orderedLanes: ScheduleLane[],
  gamesForDay: unknown[],
  resolveLaneId: (game: unknown) => string | null,
): ScheduleLane[] => {
  const hasUnassigned = gamesForDay.some((game) => !resolveLaneId(game));
  if (!hasUnassigned) return orderedLanes;
  return [
    ...orderedLanes,
    {
      _id: UNASSIGNED_LANE_ID,
      name: orderedLanes.length > 0 ? 'Unassigned' : '',
      synthetic: true,
    },
  ];
};
